<template>
    <div>
        <div class="row flex-row">
            <div class="col-md-10">
                <search-bar v-if="readyToRender">
                    <custom-select style="width:350px !important;" slot="agencies" :field="agency_field" :value="agency_field.value" :field_idx="0" @field-updated="updateFilter($event.new_value.value)">
                    </custom-select>
                    <custom-select style="width:300px !important;" slot="bookings" :field="period_field" :value="period_field.value" :field_idx="1" @field-updated="updateBookingsDateFilter($event.new_value.value)">
                    </custom-select>
                    <custom-select style="width:250px !important;" slot="canceled" :field="canceled_field" :value="canceled_field.value" :field_idx="2" @field-updated="updateCanceledFilter($event.new_value.value)">
                    </custom-select>
                </search-bar>
            </div>
            <div class="col-md-2">
                <a class="btn btn-complete btn-sm go-to-offices" :href="officesUrl" target="_blank">Effectuer une réservation</a>
            </div>
        </div>

        <div class="col-md-12">
            <one-time-locations-upcoming-reservations></one-time-locations-upcoming-reservations>
        </div>
        <!-- <div class="col-md-12">
        <one-time-locations-askings></one-time-locations-askings>
        </div> -->
    </div>
</template>

<script type="text/babel">
    import SearchBar from '../../components/OneTimeLocations/SearchBar'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import CustomSelect from 'components/Forms/Elements/Select'
    import OneTimeLocationsAskings from '../../components/OneTimeLocations/OneTimeLocationsAskings'
    import OneTimeLocationsUpcomingReservations from '../../components/OneTimeLocations/OneTimeLocationsUpcomingReservations'

    export default {
        name: "OneTimeLocations",
        components: {
            SearchBar,
            CustomSelect,
            OneTimeLocationsAskings,
            OneTimeLocationsUpcomingReservations
        },
        data() {
            return {
                dateFilterChoices: [{
                        id: 1,
                        text: 'Présentes et à venir'
                    },
                    {
                        id: 0,
                        text: 'Passées'
                    }
                ],
                canceledFilterChoices: [{
                        id: 2,
                        text: 'Aucun filtre'
                    },
                    {
                        id: 0,
                        text: 'Non'
                    },
                    {
                        id: 1,
                        text: 'Oui'
                    }
                ]
            }
        },
        mounted () {
            this.updateFilter(this.userAgenciesIdList)
        },
        methods: {
            ...mapActions('bookings', [
                'updateFilters',
                'updateBookingsDateFilter',
                'updateCanceledFilter'
            ]),
            updateFilter(value) {
                const toInsert = _.isArray(value) ? value : [value]
                this.updateFilters(toInsert)
            }
        },
        watch: {
            selectAgenciesList(newVal, oldVal) {
                this.updateFilter(this.userAgenciesIdList)
            },
            userAgenciesIdList(newVal, oldVal) {
                this.updateFilter(this.userAgenciesIdList)
            }
        },
        computed: {
            ...mapState({
                searchFilters: state => state.bookings.searchFilters,
                userAgencies: state => state.user.agencies,
                agencies: state => state.agencies
            }),
            ...mapGetters('customers', [
                'currentCustomers',
                'selectAgenciesList',
                'userAgenciesIdList'
            ]),
            agency_field () {
                return {
                    values: this.filteredAgencies,
                    multiple: false,
                    placeholder: "",
                    disabled: this.is_fetching,
                    idx: 0,
                    required: true,
                    value: this.searchFilters.agenciesID[0],
                    label: "Agence",
                    type: "select"
                }
            },
            period_field () {
                return {
                    values: this.dateFilterChoices,
                    multiple: false,
                    placeholder: "",
                    disabled: this.is_fetching,
                    idx: 1,
                    required: true,
                    value: this.dateFilterChoices[0].id,
                    label: "Période",
                    type: "select"
                }
            },
            canceled_field () {
                return {
                    values: this.canceledFilterChoices,
                    multiple: false,
                    placeholder: "",
                    disabled: this.is_fetching,
                    idx: 2,
                    required: true,
                    value: this.canceledFilterChoices[1].id,
                    label: "Annulées",
                    type: "select"
                }
            },
            filteredAgencies () {
                let v = []
                // Récupère seulement les agences non virtuelles
                const realAgencies = _.filter(this.agencies, a => !a.virtual)
                // Formate et ajoute les agences à la liste d'options
                _.map(realAgencies, (agency) => {
                    v.push({
                        id: agency.id,
                        name: agency.name
                    })
                })

                return v
            },
            readyToRender () {
                return this.agency_field.values.length > 0
            },
            officesUrl () {
                return __OFFICES_URL__ + '/location-bureau?tab=bureau_heure'
            }
        }
    }
</script>

<style lang="scss" scoped>
.flex-row {
    display: flex;
    align-items: center;
}
.go-to-offices {
    margin: 25px 0 30px;
}
</style>



// WEBPACK FOOTER //
// client/views/OneTimeLocations/OneTimeLocations.vue